import React from "react";
import styles from "./Styles.module.scss";
import { Link } from "react-router-dom";
const ShopSection = () => {
  const image = require("../../../../images/shopImage.jpg");
  return (
    <>
      <div className={styles.shopMain}>
        {/* <img src={image} alt='shopIm' /> */}
        <div>
          <p>
            Explore our wide range of products and find exactly what you need.
          </p>
          <Link to="/shop">
            <button>Visit Shop</button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default ShopSection;
